module.exports = __webpack_public_path__ + "static/Batch-Editing-9f5918fdb0b42c844f8a15286413bc9a.png";